import { ProgressBarStep } from 'components/layout/ProgressBar';
import { URLS } from 'config';
import { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { QUERY_URLS, QUOTE_URLS } from '../constants';
import { QUERY_STEPS, QUOTE_STEPS } from './constants';

export interface EnquiryProgressBarHook {
  steps: ProgressBarStep[] | undefined;
}

export default function useEnquiryProgressBar(): EnquiryProgressBarHook {
  const { pathname } = useLocation();

  const onLanding = useMemo(
    () =>
      Boolean(
        matchPath(pathname, {
          path: URLS.enquiry,
          exact: true,
          strict: true,
        }),
      ),
    [pathname],
  );

  const onQuery = useMemo(
    () =>
      QUERY_URLS.some((path) =>
        Boolean(
          matchPath(pathname, {
            path,
            exact: true,
            strict: true,
          }),
        ),
      ),
    [pathname],
  );

  const onQuote = useMemo(
    () =>
      QUOTE_URLS.some((path) =>
        Boolean(
          matchPath(pathname, {
            path,
            exact: true,
            strict: true,
          }),
        ),
      ),
    [pathname],
  );

  const steps = useMemo(() => {
    if (onLanding) return undefined;
    if (onQuery) return QUERY_STEPS;
    if (onQuote) return QUOTE_STEPS;
    return undefined;
  }, [onLanding, onQuery, onQuote]);

  return {
    steps,
  };
}
